import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, RefreshIconButton, useRefresh
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, Button, DialogActions, DialogContent, Dialog, CircularProgress
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import MessageIcon from '@material-ui/icons/Message';
import ImageGalleryDialog from './components/ImageGalleryDialog';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import { io } from 'socket.io-client'

const socket = io(`${config.HOST_NAME}`, { transports: ['websocket', 'polling', 'flashsocket'] })

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "OPERATOR PATROLLING"

export const OperatorPatrolling = props => {
    const refresh = useRefresh();
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));
   


    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [highLightRecordIds, setHighLightRecordIds] = useState({})

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const postRowStyle = (record, index) => {
        return {animation: record && +record.id === highLightRecordIds[record.id] ? "blinkingBackground 2s infinite" : ""};
    }

    useEffect(() => {
        eventTracker(CATEGORY, "NEWSLETTER SUBSCRIBERS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        socket.on('connnection', () => {
            console.log('connected to server');
        })
        socket.on(`OPERATOR_PATROLLING_MESSAGES`, ({ inserted_log_id }) => {
            refresh()
            setHighLightRecordIds((prev) => {
                return { ...prev, [inserted_log_id]: inserted_log_id }
            })
            setTimeout(() => {
                setHighLightRecordIds((prev) => {
                    const records = { ...prev };
                    delete records[inserted_log_id];
                    return records
                })
            }, 5000);
        })

        socket.on('message', (message) => {
            console.log(message);
        })

        socket.on('disconnect', () => {
            console.log('Socket disconnecting');
        })

    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
          <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <RefreshIconButton size={25} color="primary" />
        </div>

        <List
        style={{marginTop:20}}
            {...props}
            title="Operator Patrolling"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            sort={{ field: 'created_on', order: 'DESC' }}
            empty={false}
            pagination={<CustomPagination />}
            actions={false}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.parking_name}
                        secondaryText={record => (<div>
                            {record.search && <div><span style={{ color: "#5a5a5a" }}>Search: </span>{record.search}</div>}
                            {record.flat && <div><span style={{ color: "#5a5a5a" }}>Flat Name: </span>{record.flat}</div>}
                            {record.tower && <div><span style={{ color: "#5a5a5a" }}>Tower Name: </span>{record.tower}</div>}
                            {record.operator_device_id && <div><span style={{ color: "#5a5a5a" }}>Device ID: </span>{record.operator_device_id}</div>}
                            {record.created_on && <div><span style={{ color: "#5a5a5a" }}>Time: </span>{renderTime(record["created_on"])}</div>}
                           {!viewOnly && record && record.is_notified === 1 && <div style={{ display: "flex", gap: 10, justifyContent: 'space-between', alignItems: "center" }}>
                            <OperatorMessages {...props} label={false} record={record} />
                            </div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable} rowStyle={postRowStyle}>
                        <TextField source='search' label="Search" />
                        <TextField source='flat' label="Flat Name" />
                        <TextField source='tower' label="Tower Name" />
                        <TextField source='operator_device_id' label="Device ID" />
                        <TextField source='parking_name' label="Parking Name" />
                        <FunctionField source="created_on" label="Time" render={record => record["created_on"] ? renderTime(record["created_on"]) : '-'} sortable={true} />
                        {!viewOnly && <FunctionField source="is_notified" label="Message" render={record => record && record.is_notified === 1 ? <OperatorMessages {...props} label={false} record={record} /> : null} />}
                    </Datagrid>
            }
        </List>
    </div>
};

function OperatorMessages(props) {
    const {record} = props
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const [messages , setMessages] = React.useState([])

    const openDialog = () => {
        setDialogVisible(true);
        fetchOperatorMessages();
    };

    const closeDialog = () => {
        setDialogVisible(false);
        setMessages([])

    };

    const fetchOperatorMessages = () => {

        if(!record.id) return notify("Required ID", "warning")
        if(!record.vehicle_id) return notify("Required Vehicle ID", "warning")
        if(!record.access_key_id) return notify("Required Access Key ID", "warning")

        setLoading(true);
        fetch(`${config.HOST_NAME}/crm/v3/operatorMessages/${record.id}?vehicle_id=${record.vehicle_id}&access_key_id=${record.access_key_id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            }
        })
            .then(response => response.json())
            .then((json) => {
                if (json.success) setMessages(json.data)
                else notify(json.message, 'warning');

            })
            .catch((e) => notify('Error Deleting Operator Device', 'warning'))
            .finally(() =>setLoading(false))
    };

    return (
        <>
            <Button title='Messages' style={{ color: customTheme.palette.primary.main }} onClick={openDialog}  label={false}> <MessageIcon style={{ fontSize: "20px" }} /></Button>
            <Dialog open={dialogVisible} onClose={closeDialog}>
                <DialogContent style={{ paddingBottom: 20 }}>
                    <p style={{ fontWeight: 'bold', fontSize: 15 }}>Operator Messages</p>
                    <p style={{ fontSize: 13, color: '#BDBDBD' }}>{record.parking_name}</p>
                    {messages[0] && <div style={{ height: 180, overflowX: 'hidden', overflowY: 'scroll' }}>
                        {messages.map((message) => (
                            <div style={{ backgroundColor: "#5E8DD310", marginBottom: 10, marginRight: 20, padding: 10, borderRadius: 10 }}>
                                <div>
                                    <div style={{ maxWidth: 250 }}>
                                        <p style={{ fontSize: 12, color: '#18CC69', lineHeight: "3px", fontWeight: '600' }}>{record.vehicle_number}</p>

                                        {message.images ?
                                            <ImageGalleryDialog
                                                thumbnail={true}
                                                record={message}
                                                style={{ textAlign: 'left' }}
                                                getImages={(record) => [...JSON.parse(record.images)]}
                                            />
                                            :
                                            <div style={{ display: isSmallDevice ? 'block' : "flex", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                                    <BrokenImageOutlinedIcon />
                                                </div>
                                            </div>
                                        }

                                        <p style={{ fontSize: 12, color: '#272727', fontWeight: '600', marginTop: -3 }}>{message.text}</p>
                                    </div>
                                </div>
                                {message.sent_on && <p style={{ fontSize: 10, color: '#272727', textAlign: 'end' }}>Sent on {moment(message.sent_on).format('MMMM Do YYYY, h:mm A')}</p>}
                                {message.delivered_on && <p style={{ fontSize: 10, color: '#272727', textAlign: 'end', marginTop: -10 }}>Delivered on {moment(message.delivered_on).format('MMMM Do YYYY, h:mm A')}</p>}
                                {message.read_on && <p style={{ fontSize: 10, color: '#272727', textAlign: 'end', marginTop: -10 }}>Read on {moment(message.read_on).format('MMMM Do YYYY, h:mm A')}</p>}
                            </div>
                          
                        ))}
                    </div>}

                    {!messages[0] && loading &&  <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                        <CircularProgress color="primary" size={20} />
                        </div>}

                    {!messages[0] && !loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ fontSize: 12, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>No Messages Found.</p>
                    </div>}

                </DialogContent>

                <DialogActions style={{paddingBottom:20, paddingRight: 20}}>
                    <Button onClick={closeDialog} style={{ backgroundColor: customTheme.palette.neutral.main, color: customTheme.palette.secondary.main, textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px" }}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}